import "@ingka/svg-icon/style.scss";
import "./GridCard.scss";

const GridCard = ({ title, icon, onClick }) => {
  const handleOnClick = () => {
    onClick();
  };
  return (
    <div
      onClick={handleOnClick}
      className="card card--without-image card--emphasised card--compact card--trailing-image"
      style={{ backgroundColor: "#F5F5F5" }}
    >
      <div className="card__info">
        <div className="card__text-wrapper">
          <h2 className="card__title">{title}</h2>
        </div>
        <div className="card__body">
          <div className="card__body-center-icon-container">
            <img alt="item logo" src={icon} className="center-icon" />
          </div>
        </div>
        <span className="card__cta">
          <span className="card__btn btn btn--icon-primary-inverse btn--small">
            <span className="btn__inner">
              <svg
                focusable="false"
                viewBox="0 0 24 24"
                className="svg-icon card__icon"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="m20.0008 12.0001-8-8.001-1.4143 1.414L16.1727 11H4v2h12.1723l-5.5868 5.5866 1.4141 1.4142 8.0012-8.0007z"
                ></path>
              </svg>
            </span>
          </span>
        </span>
      </div>
    </div>
  );
};

export default GridCard;
